import { LinkIcon } from 'src/svg/LinkIcon';
import { InviteIcon } from 'src/svg/InviteIcon';
import { GiftIcon } from 'src/svg/GiftIcon';

export const config = [
  {
    id: 0,
    Icon: LinkIcon,
    text: 'referral.stepOne'
  },
  {
    id: 1,
    Icon: InviteIcon,
    text: 'referral.stepTwo'
  },
  {
    id: 2,
    Icon: GiftIcon,
    text: 'referral.stepThree'
  }
];
